import "./BasementRemodeling.module.css";
import Header from "@/reusable_sections/Header";
import ServiceHero from "./sections/ServiceHero";
import BasementGuide from "./sections/BasementGuide";
import BasementFaq from "./sections/BasementFaq";
import RelatedLinksAndEstimateForm from "./sections/RelatedLinksAndEstimateForm";
import Footer from "@/reusable_sections/Footer";
export default function BasementRemodelingPage() {
  return <div>
      <Header />
      <ServiceHero />
      <BasementGuide />
      <BasementFaq />
      <RelatedLinksAndEstimateForm />
      <Footer />
    </div>;
}